import React from "react";

import { SupportingDocsSection } from "./SupportingDocsSection";

import type { ExperimentFormData } from "../../types/experiment.types";

interface SupportingMaterialsSectionProps {
  experimentData: ExperimentFormData;
  setExperimentData: (updater: (prev: ExperimentFormData) => ExperimentFormData) => void;
}

export const SupportingMaterialsSection: React.FC<SupportingMaterialsSectionProps> = ({
  experimentData,
  setExperimentData,
}) => {
  return (
    <div className="space-y-8">
      <SupportingDocsSection
        experimentData={experimentData}
        setExperimentData={setExperimentData}
      />
    </div>
  );
};
